import { Tabs } from "flowbite-react";
import PartnerInfo from "../form/PartnerInfo";
import { ImageSelfPartnerBlock } from "../settings-block/ImageSelfPartner.block";
import { PartnerAddress } from "../settings-block/PartnerAddress";
import { FaAddressCard, FaHome } from "react-icons/fa";
import { vehicleTheme } from "../../../vehicles/components/vehicle-dashboard/TabsVehicle";
import { FaCircleUser } from "react-icons/fa6";
import { MdPayments } from "react-icons/md";
import { PartnerPaymentsTable } from "../settings-block/PartnerPaymentsTable";

export function PartnerDashboard() {
  return (
    <div className="relative flex justify-center w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      <section className="max-w-7xl w-full p-2">
        <Tabs
          className="tabs-style"
          theme={vehicleTheme}
          aria-label="Default tabs"
        >
          <Tabs.Item
            icon={FaCircleUser}
            title={
              <div className="tabs-name-style">
                Parceiro
              </div>
            }
          >
            <ImageSelfPartnerBlock />
          </Tabs.Item>

          <Tabs.Item
            icon={MdPayments}
            title={
              <div className="tabs-name-style">
                Pagamentos
              </div>
            }
          >
            <PartnerPaymentsTable />
          </Tabs.Item>
          <Tabs.Item
            icon={FaAddressCard}
            title={
              <div className="tabs-name-style">
                Informações
              </div>
            }
          >
            <PartnerInfo />
          </Tabs.Item>

          <Tabs.Item
            icon={FaHome}
            title={
              <div className="tabs-name-style">
                Endereço
              </div>
            }
          >
            <PartnerAddress />
          </Tabs.Item>


        </Tabs>
      </section>

    </div>
  )
}